import { NotificationSettings } from './NotificationSettings';

export enum CompanyEmailFormat {
    YARDI = 'YARDI',
    RealPage = 'REAL_PAGE',
    MeetElise = 'MEET_ELISE',
    ADF = 'ADF',
    KNOCK = 'KNOCK',
    HTML = 'HTML',
    ENQUIRE = 'ENQUIRE',
    ENTRATA = 'ENTRATA'
}

export interface CompanyAddress {
    address1: string;
    address2: string | null;
    city: string;
    state: string;
    zipcode: string;
    /** Two-letter country code, e.g., 'US' or 'CA' */
    country: string;
}

export interface NotificationBarLink {
    caption: string;
    url: string;
}

export type MeetEliseModule = {
    enabled: boolean;
    title?: string;
    sortOrder?: number;
}

export type MeetEliseModules = {
    chat?: MeetEliseModule;
    tour?: MeetEliseModule;
    email?: MeetEliseModule;
    text?: MeetEliseModule;
};

export type MeetEliseConfig = {
    enabled: boolean;
    modules: MeetEliseModules;
}

export const DefaultMeetEliseModules: MeetEliseModules = {
    chat: { title: 'Chat with us', enabled: false, sortOrder: 10 },
    tour: { title: 'Book a tour', enabled: false, sortOrder: 20 },
    email: { title: 'Email an agent', enabled: false, sortOrder: 30 },
    text: { title: 'Call or text us', enabled: false, sortOrder: 40 },
};


export interface Company extends NotificationSettings, CompanyAddress {
    id: number;
    created_at: string;
    updated_at: string | null;
    updated_by: string;
    deleted_at: string | null;
    name: string;
    displayName?: string;
    state: string;
    website_url: string;
    is_test: boolean;
    is_universal: boolean;
    is_paused: boolean;
    dma: number | null;
    assigned_users?: any[];
    logo: string | null;
    enquire_portal_id: number | null;
    weekly_notification: boolean;
    meet_elise_config?: MeetEliseConfig | null;
    rev_link_google: string | null;
    rev_link_yelp: string;
    rev_link_google_small: string;
    rev_link_yelp_small: string;
    rev_link_google_date: string | null;
    rev_link_yelp_date: string | null;
    business_category_id: number | null;
    active: boolean;
    country: string;
    ownership_group?: string;
    ownership_group_id: null | number;
    property_management_company_id: null | number;
    region_id: null | number;
    request_review_google: string;
    request_review_yelp: string;
    property_management?: string;
    weekly_lead_notification_email: string | null;
    include_company_name_in_email_header: boolean;
    agency_id?: number;
    notification_bar_message: string | null;
    notification_bar_color: string;
    notification_bar_background_color: string;
    notification_bar_links: NotificationBarLink[];
    notification_bar_start_date?: string | null;
    notification_bar_end_date?: string | null;
    notification_bar_active: boolean;
    notification_bar_automated?: boolean;
    notification_bar_position?: string;
    time_zone: string;
    full_name?: string;
    trial_end_date: string;
    forwardNumbers: any[];
    companyFeatures: any[];
    apiKeys: [];
    lead_notification_cc_emails: string | null;
    estimate_multiplier: null;
    custom_disclaimer: null;
    active_coupon_id: null;
    expiration_date: string | Date | null;
    crmConfig: {
        id: number;
        company_id: number;
        crm_type: string;
        name: string;
        configuration: { crm_emails: string[] };
        created_at: string;
        updated_at: null | string;
        ruleset: { rules: any[] };
    } | null;
    realyncAccountId?: string | null;
    label: string;
    logo_background_color?: 'white' | 'gray';
}

export type AccessibleCompany = Company;

export type FilterCompany = {
    id: number,
    name: string,
    dma: number | null;
    active: boolean;
    is_test: boolean;
}
